export enum RecommendationsProductActionsTypes {
  CHECK_RECOMMENDATIONS_PRODUCTS_REQUEST = 'recommendationsProduct/CHECK_RECOMMENDATIONS_PRODUCTS_REQUEST',
  SET_IS_REQUEST = 'recommendationsProduct/SET_IS_REQUEST',
  SET_RECOMMENDATION_PRODUCT_MAP = 'recommendationsProduct/SET_RECOMMENDATION_PRODUCT_MAP',
  ADD_RECOMMENDATION_PRODUCT_IN_BASKET = 'ADD_RECOMMENDATION_PRODUCT_IN_BASKET',
}
